<script setup>
  const { small } = defineProps({ small: Boolean });
</script>

<!----------------------------------------------------------------------------->

<template>
  <i :class="{ small }" />
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  i {
    display: inline-block;

    width: px(4);
    height: px(4);

    background-color: currentColor;
    border-radius: 100%;

    margin: -0.1em 0.25em 0;

    &.small {
      width: px(2);
      height: px(2);
    }
  }
</style>
